<template>
    <div class="main bg-g-white-transparent">
        <div class="d-flex position-sticky align-items-center flex-column flex-lg-row">
            <SearchBar />
        </div>
        <section id="brn-attractions">
            <template v-if="filterAttractions.length">
                <div class="attractions-list">
                    <template>
                        <AttractionCard
                            v-for="attraction in filterAttractions"
                            :key="attraction.id"
                            :attraction="attraction"
                            @move-map="moveCenter(attraction)" />
                    </template>

                </div>
                <div class="map">
                    <GoogleMap ref="map" @ready="mapReady" style="display: block; height: 100%;"/>
                </div>
            </template>
            <div v-else class="flex-grow-1 text-center mt-5">
                <h3>Attractions not found</h3>
            </div>
        </section>

    </div>
</template>

<script>
import PageLayoutContentMixin from "../../mixins/ContentMixin";
import SettingsMixin from "../../mixins/SettingsMixin";
import GoogleMap from "../components/elements/GoogleMap";
import AttractionCard from "../components/cards/AttractionCard";
import ApiRequest from "../../utils/api-request";
import SearchBar from "../components/elements/SearchBar";
export default {
    name: "Attractions",
    components: {SearchBar, AttractionCard, GoogleMap},
    mixins: [PageLayoutContentMixin, SettingsMixin],
    data() {
        return {
            attractions: []
        }
    },
    computed: {
        keyword: {
            get: function () {
                return this.$store.getters['filter/keyword']
            },
            set: function (value) {
                this.$store.commit('filter/SET_KEYWORD', value)
            }
        },
        filterAttractions() {
            return this.keyword ? this.attractions?.filter(a => a.title.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1) : this.attractions;
        }
    },
    methods: {
        mapReady() {
            this.attractions.forEach(attraction => {
                attraction.position = {
                    lat: parseFloat(attraction.location.split(',')[0]),
                    lng: parseFloat(attraction.location.split(',')[1])
                };
                this.$refs.map.addMarker({
                    ...attraction,
                    logoUrl: attraction.image
                })
            });
        },
        moveCenter(attraction) {
            this.$refs.map.moveCenter(attraction.location.split(',')[0],attraction.location.split(',')[1]);
        },

    },
    mounted() {
        new ApiRequest().getAttractions().then(response => {
            this.attractions = response.data.data;
            this.attractions.forEach(attraction => {
                attraction.position = {
                    lat: parseFloat(attraction.location.split(',')[0]),
                    lng: parseFloat(attraction.location.split(',')[1])
                };
            });
        });
    }
}
</script>

<style scoped>

</style>
